<template>
  <div class="common-top"  :style="{backgroundColor:boxBodyColor}">
    <!-- <img src="../../assets/back@2x.png" :class="[showCloseBtnAndBackBtn ? 'imgHead':'imgHead2']"  @click="handleBack">
    <img class="imgUrl" v-if="displayMode == 2" :src="imgSrc">
    <span v-else>{{name}}</span>
    <img src="../../assets/close@2x.png" :class="[showCloseBtnAndBackBtn ? 'imgHeadB':'imgHeadB2']" v-if="closeis" @click="handleClose">
    <img src="../../assets/close@2x.png" :class="[showCloseBtnAndBackBtn ? 'imgHeadB':'imgHeadB2']" v-else >
    <div class="fixedBtn call" @click="gocall" v-show= 'callCenterEnable'>
        <div  v-if="callCenterEnable" class="serviceCon">
          <img src="/static/assets/callbtn.png">
          <p>客服电话</p>
        </div>
    </div> -->

    <!-- <div class="modal" v-show="nclose">
      <div class="mint-msgbox-wrapper" style="z-index:2001">
          <div class="mint-msgbox">
            <div class="mint-msgbox-header">
              <div class="mint-msgbox-title">提示</div>
            </div>
            <div class="mint-msgbox-content">
              <div class="mint-msgbox-message" style="font-weight:normal">确定要退出客服吗?</div>
            </div>
            <div class="mint-msgbox-btns">
              <button class="mint-msgbox-btn mint-msgbox-cancel " @click="nclose = false">取消</button>
              <button class="mint-msgbox-btn mint-msgbox-confirm " @click="realclose">确定</button>
            </div>

          </div>
      </div>

    </div> -->
    <img v-if="displayMode == 2" :src="logoUrl" alt="公司logo">
    <p  v-else class="companyName">
      <span v-if="companyName == ''"></span>

      <el-tooltip v-else-if="companyName.length > 10" :content="companyName" placement="top" effect="light">
        <span>{{companyName.substring(0,10) + '...'}}</span>
      </el-tooltip>

      <span v-else>{{companyName}}</span>
    </p>
    <div class="tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="首页" name="0">首页</el-tab-pane>
      </el-tabs>
    </div>
    <div class="orderAndService">
      <img class="order-logo" :src="imgUrl + 'im_logo.png'" alt="单据logo" @click="workOrder">
      <span class="order" @click="workOrder">我的单据</span>

      <div class="im-content" v-if="iskf" @click="intoIm">
        <p class="line"></p>
        <img src="../../assets/customer-icon.png" alt="">
        <span class="order">在线客服</span>
      </div>
    </div>
  </div>
</template>
<script>
import * as Url from '@/components/url.js'
export default {
    props: {
      isOrder: {
        type: Boolean,
        default: false
      },
      iskf: {
        type: Boolean,
        default: false
      },
    },
    data () {
      return {
        basicUrl:Url.baseurl,
        boxBodyColor: '',
        limitVipLevel: '',
        visitorVipLevel: '',
        logoUrl:'',
        companyName:'',
        displayMode:'',
        imgUrl: '/pc/static/assets/',
        visitorMd5Code: '',
        customPicture: '',
        defaultPictureNo:'',
        headPictureUrl:'',
        spiritSrc:'',
        callis : false,
        activeName: '0',
        homeType: ''
        //msg: '服务器繁忙，请稍后再试'
      }
    },
    methods: {
      handleClick() {
        const url = sessionStorage.getItem('indexUrl')
        const md5 = sessionStorage.getItem('md5')
        if (!url) {
          return
        }
        this.$router.push({
          path: url,
          query: {
            v: md5
          }
        })
      },
      workOrder() {
        // 点击我的单据日志埋点
        if (this.homeType == 5) {
          this.$Points.point({code: '1001', type: '4'});
        }
        this.$router.replace({path: 'myorder'})
      },
      callgo() {
        var userAgent = checkBrowser();
        var changeis = true;
        if(userAgent == '谷歌'){
          changeis = true;
          var banben = getChromeVersion();
          console.log('浏览器版本：'+banben)
          if(banben < 52){
            changeis = false;
          }
        }else{
          changeis = false;
        }
        if(changeis){
          window.location.href = '#/callcenter';
        }else{
            if(userAgent != "Safari"){
              this.$message({
                message: '目前呼叫只支持Chrome浏览器，版本号 52以上~',
                type: 'warning'
              })
            }else{
              alert('目前呼叫只支持Chrome浏览器，版本号 52以上~');
            }
        }

      },
      /*定位到最新的消息位置*/
      intoIm(){
        this.$emit('intoIm')
      },
    },
    mounted() {
      let userAgent = navigator.userAgent;

      this.visitorMd5Code = sessionStorage.getItem('md5')
      this.boxBodyColor = sessionStorage.getItem('boxBodyColor')
      this.companyName = sessionStorage.getItem('companyName')

      this.logoUrl = sessionStorage.getItem('logoUrl')
      this.displayMode = sessionStorage.getItem('displayMode');

      this.customPicture = sessionStorage.getItem('customPicture')
      this.defaultPictureNo = sessionStorage.getItem('defaultPictureNo')
      this.headPictureUrl = sessionStorage.getItem('headPictureUrl')
      this.homeType = sessionStorage.getItem('redirectTarget')
      if(this.customPicture == 'true'){
        this.spiritSrc = this.headPictureUrl
      }else {
        if(this.defaultPictureNo == 2){
          this.spiritSrc = '/pc/static/assets/spirit2.png'
        }else if(this.defaultPictureNo == 3){
          this.spiritSrc = '/pc/static/assets/spirit3.png'
        }else{
          this.spiritSrc = '/pc/static/assets/spirit1.png'
        }
      }
    }
}
</script>
<style scoped>
.common-top {
  display: flex;
  align-items: center;
  background-color: #009688;
  justify-content: space-between;
  height: 45px;
  font-size: 14px;
  color: #f4f9f8;
}
.common-top > img {
  height: 35px;
  width: auto;
  margin-left: 20px;
}
.orderAndService {
  display: flex;
  align-items: center;
}
.order {
  margin: 0 20px 0 7px;
  cursor: pointer;
}
.orderAndService > img {
  cursor: pointer;
}
.order-logo {
  height: 18px;
}
.im-content {
  display: flex;
  align-items: center;
}
.im-content .line {
  height: 20px;
  margin-right: 12px;
  border-left: 1px solid rgba(255,255,255,0.3);
}
.im-content img {
  height: 18px;
}
.im-content span {
  margin-left: 7px;
}
.tabs {
  float: left;
  display: flex;
  flex: 1;
  line-height: 0;
  padding-left: 20px;
}
</style>
<style>
.tabs .el-tabs__header {
  margin: 0;
  border: none;
}
.tabs .el-tabs__item {
  color: #fff;
  padding: 0;
}
.tabs .el-tabs__item.is-active {
    color: #fff;
}
.tabs .el-tabs__active-bar {
  border-radius: 3px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/top.vue?4b811ade